/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import faker from 'faker';
import { Factory } from 'miragejs';

import { CALL_RESCUE_TEST_STATUS } from '../../call-rescue-monitor/constants';

const callRescueTestCall = Factory.extend({
  id: () => faker.datatype.uuid(),
  account: () => ({
    id: faker.datatype.uuid(),
    name: `${faker.name.firstName()} ${faker.name.lastName()}`,
  }),
  phone_called: () => ({
    id: faker.datatype.uuid(),
    number: faker.phone.phoneNumberFormat().replace(/\W+/g, ''),
    digits_after_call: null,
  }),
  phone_calling: () => ({
    id: faker.datatype.uuid(),
    number: faker.phone.phoneNumberFormat().replace(/\W+/g, ''),
    phone_type: 1,
  }),
  retry_count: () => 0,
  call_status: () => faker.random.arrayElement(Object.values(CALL_RESCUE_TEST_STATUS)),
  created_at: () => faker.date.past(),
  updated_at() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this.created_at;
  },
});

export default callRescueTestCall;
